import * as React from 'react';

import PlusBadge16 from './PlusBadge16';

export const plusBadge16 = () => <PlusBadge16 />;

export default {
    title: 'Icon|Fill|PlusBadge16',
    component: PlusBadge16,
    parameters: {
        notes: "`import PlusBadge16 from 'box-ui-elements/es/icon/fill/PlusBadge16';`",
    },
};
